// Environment variable helper for Vite
// Provides backward compatibility with CRA's process.env.REACT_APP_* pattern

// Helper function to compute runtime URIs based on current domain
const getBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return '';
};

const env = {
  // Environment-specific values (from CloudFormation/build-time)
  API_URL: import.meta.env.VITE_API_URL || '',
  COGNITO_DOMAIN: import.meta.env.VITE_COGNITO_DOMAIN || '',
  COGNITO_CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',

  // Hardcoded constants (same across all environments)
  AWS_REGION: 'us-east-1',
  REQUIRED_COGNITO_GROUP: 'mentoring',
  LOCATION_REGION: 'us-east-1',
  
  // Computed at runtime based on current domain
  get REDIRECT_URI(): string {
    return `${getBaseUrl()}/oauth2/idpresponse`;
  },
  get LOGOUT_URI(): string {
    return `${getBaseUrl()}/login`;
  },
};

export default env;
